import gsap from "gsap"
import Experience from "../../Experience"
import Fog from "../Fog"
import Axes from "./Axes"
import * as THREE from 'three'
import EventEmitter from "../../Utils/EventEmitter"

export default class Sphere extends EventEmitter {
    constructor() {
        super()
        this.experience = new Experience()
        this.scene = this.experience.scene

        this.raycaster = new THREE.Raycaster()
        this.mouse = new THREE.Vector2()

        this.sizeMultiplier = 1

        this.fog = null

        window.addEventListener('mousemove', this.onMouseMove.bind(this))
        window.addEventListener('click', this.onClick.bind(this))
    }
    onMouseMove(event) {
        if (!this.interactive) return;
        this.mouse.x = (event.offsetX / this.experience.sizes.width) * 2 - 1
        this.mouse.y = -(event.offsetY / this.experience.sizes.height) * 2 + 1

        const raycaster = new THREE.Raycaster()
        raycaster.setFromCamera(this.mouse, this.experience.camera.instance)
        const intersects = raycaster.intersectObject(this.mousePlane)
        if (intersects.length > 0) {
            const intersectPoint = intersects[0].point
            this.fog.hoverFog(intersectPoint)
            this.setPointer()
        } else {
            this.setDefaultCursor()
        }
    }
    setPointer() {
        document.body.style.cursor = 'pointer'
    }
    setDefaultCursor() {
        document.body.style.cursor = 'default'
    }
    getRadius() {
        const box = new THREE.Box3().setFromObject(this.mesh)
        const boundingSphere = box.getBoundingSphere(new THREE.Sphere())

        const size = box.getSize(new THREE.Vector3())
        this.fog = new Fog(size.y * this.sizeMultiplier, this.axes)
        return boundingSphere.radius
    }
    setSphereCenter() {
        const box = new THREE.Box3().setFromObject(this.mesh)
        const helper = new THREE.BoxHelper(this.mesh, 0x00ff00)
        // this.scene.add(helper)
        return box.getCenter(new THREE.Vector3())
    }
    setAxes() {
        this.axes = new Axes(this)
        this.axes.on('axesChanged', (data) => {
            this.fog.updateValues(data)
        })
        this.fog.axes = this.axes

        this.axes.checkInitialValues()

        this.createMousePlane()
    }
    createMousePlane() {
        const planeGeometry = new THREE.PlaneGeometry((this.center.y - 1) * 2, (this.center.y - 1) * 2)


        const planeMaterial = new THREE.MeshBasicMaterial({
            color: 0xffffff, opacity: 0.0, transparent: true,
            depthWrite: false,
            depthTest: false
        })
        const plane = new THREE.Mesh(planeGeometry, planeMaterial)
        plane.position.set(0, this.center.y, 0)
        this.mousePlane = plane
        this.scene.add(plane)
        plane.lookAt(this.experience.camera.instance.position)
        return plane
    }
    onClick(event) {
        if (!this.interactive) return;
        // Update the mouse vector to current mouse position
        const mouse = new THREE.Vector2(
            (event.offsetX / this.experience.sizes.width) * 2 - 1,
            -(event.offsetY / this.experience.sizes.height) * 2 + 1
        );

        // Set the raycaster
        this.raycaster.setFromCamera(mouse, this.experience.camera.instance);

        // Calculate objects intersecting the ray
        const intersects = this.raycaster.intersectObject(this.mousePlane);

        if (intersects.length > 0) {
            const intersectPoint = intersects[0].point;

            // Animate the fog to the clicked position
            if (this.fog && typeof this.fog.animateToPosition === 'function') {
                const duration = 2; // Duration in seconds
                this.fog.animateToPosition(duration, intersectPoint);

                const result = this.fog.invertPositionToAxes(intersectPoint);
                const keys = Object.keys(result);


                // 'east' = 'suess',
                // 'west' = 'sauer',
                // 'north' = 'salzig',
                // 'south' = 'scharf',
                // 'center' = 'umami'


                const suessValue = result['east']
                const sauerValue = result['west']
                const salzigValue = result['north']
                const scharfValue = result['south']
                const umamiValue = result['center']


                // Check if the current URL path contains /en/ to determine if the site is in English
                const isEnglish = window.location.pathname.includes('/en/');
                
                // Construct the URL with /en/ prefix if the site is in English
                const searchUrl = isEnglish
                    ? `${window.location.origin}/en/?taste_search=1&suess=${suessValue}&sauer=${sauerValue}&salzig=${salzigValue}&scharf=${scharfValue}&umami=${umamiValue}`
                    : `${window.location.origin}/?taste_search=1&suess=${suessValue}&sauer=${sauerValue}&salzig=${salzigValue}&scharf=${scharfValue}&umami=${umamiValue}`;

                fetch(searchUrl)
                    .then(response => response.text())
                    .then(html => {
                        // Navigate to the search results page
                        window.location.href = searchUrl;
                    });

            }
        }
    }
    rotateIn() {
        gsap.to(this.mesh.rotation, {
            y: Math.PI * 2,
            duration: 5,
            ease: 'power3.out',
            onComplete: () => {
            }

        })
    }
    update() {
        if (this.fog) this.fog.update()
    }



}